import type { CategoryHierarchy } from '@/gen/ecom'

export interface BreadcrumbItem {
  id: string | undefined
  name: string | undefined
  url: string | undefined
}
export const getCategoryBranch = (id: string, categories: CategoryHierarchy[]): BreadcrumbItem[] => {
  const findCategoryBranch = (
    id = '',
    categories: CategoryHierarchy[] = [],
    branch: BreadcrumbItem[] = []
  ): BreadcrumbItem[] => {
    for (const category of categories) {
      if (category.id === id) {
        return [...branch, { id: category.id, name: category.name, url: category.url }]
      }

      if (category.subcategories) {
        const foundBranch = findCategoryBranch(id, category.subcategories, [
          ...branch,
          { id: category.id, name: category.name, url: category.url },
        ])
        if (foundBranch.length) {
          return foundBranch
        }
      }
    }

    return []
  }

  return findCategoryBranch(id, categories)
}
